import React, { useCallback, useState, useEffect } from 'react'
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Label,
  Input,
  CardHeader,
  Alert
} from "reactstrap"
import ApiService from '../../../Services/ApiService';
import AlertService from '../../../Services/alertService'
import { SUCCESS_KEY } from '../../../Constants/MainKeys'
import uuid from 'react-uuid'
import { addButtonSpinner, removeButtonSpinner } from '../../../store/spinner/actions'
import { useDispatch, useSelector } from 'react-redux'
import ActionButton from '../../../components/Buttons/ActionButton'

const buttonSpinnerId = uuid();

const InstantPaymentForm = (props) => {

  const { clearFilter } = props;
  const dispatch = useDispatch();
  const maxAmount = 1000000000;
  const transactionTextMaxCount = 2000;
  let spinnerColor = "#556EE6";
  const { user } = useSelector(state => state.Login);
  const [isShowInstantPaymentForm, setIsShowInstantPaymentForm] = useState(false);

  const [values, setValues] = useState({
    amount: "",
    transactionText: "",
    endDate: "",
    endTime: "",
    customerFullName: "",
    customerEmail: "",
  })


  const onNumberChange = (event, fieldName, maxLength = null) => {
    if (typeof +event.target.value === "number" && Number(event.target.value) >= 0 && Number(event.target.value) <= maxLength) {
      setValues(values => ({ ...values, [fieldName]: +event.target.value ? +event.target.value : "" }))
    }
  };

  const onChange = (event, fieldName, maxLength = null) => {
    if (maxLength && maxLength < event.target.value.length) { return; }
    setValues(values => ({ ...values, [fieldName]: event.target.value }))
  }

  const resetFields = () => {
    setValues({
      amount: "",
      transactionText: "",
      endDate: "",
      endTime: "",
      customerFullName: "",
      customerEmail: "",
    })
  }

  const getToday = () => {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    return today = yyyy + '-' + mm + '-' + dd;
  }

  const getTomorrow = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const dd = String(tomorrow.getDate()).padStart(2, '0');
    const mm = String(tomorrow.getMonth() + 1).padStart(2, '0');
    const yyyy = tomorrow.getFullYear();
    return yyyy + '-' + mm + '-' + dd;
  }

  const getCurrentTime = () => {
    const now = new Date();
    const hh = String(now.getHours()).padStart(2, '0');
    const mm = String(now.getMinutes()).padStart(2, '0');
    return hh + ':' + mm;
  }

  useEffect(() => {
    if (isShowInstantPaymentForm) {
      setValues(prev => ({
        ...prev,
        endDate: getTomorrow(),
        endTime: getCurrentTime()
      }));
    }
  }, [isShowInstantPaymentForm])

  const onSubmit = (event) => {
    event.preventDefault();
    setButtonSpinner(buttonSpinnerId);
    const data = {
      amount: values.amount,
      transactionText: values.transactionText,
      expireDateString: values.endDate,
      expireTimeString: values.endTime,
      timeZoneOffset: Number(new Date().getTimezoneOffset() / 60),
      customerFullName: values.customerFullName,
      customerEmail: values.customerEmail,
    }
    ApiService.createInstantPayment(data).then(response => {
      if (response && response.data) {
        AlertService.alert(SUCCESS_KEY, "Instant payment created successfully");
        resetFields();
        clearFilter && clearFilter();
        closeInstantPaymentForm();
      }
    }).catch(error => getFail(error)).finally(() => {
      extractButtonSpinner(buttonSpinnerId);
    });
  }

  const closeInstantPaymentForm = () => {
    setIsShowInstantPaymentForm(false);
    setValues({
      amount: "",
      transactionText: "",
      endDate: "",
      endTime: "",
      customerFullName: "",
      customerEmail: "",
    })
  }

  const onDateChange = (event, fieldName) => {
    setValues(prevFilter => ({ ...prevFilter, [fieldName]: event.target.value }))
  }

  const setButtonSpinner = useCallback(spinner => {
    dispatch(addButtonSpinner(spinner));
  }, []);

  const extractButtonSpinner = useCallback(spinner => {
    dispatch(removeButtonSpinner(spinner));
  }, []);

  const getFail = (error, spinnerId) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || "error"), error);
    spinnerId && extractButtonSpinner(spinnerId);
  }

  return (
    <Col lg={12}>
      <Row className='mb-4'>

        <Col sm={12}>
          <Card className='position-relative p-3 mb-0'>
            <CardHeader className="bg-transparent p-0">
              <div className='d-md-flex align-items-end justify-content-between'>
                <p className='text-md-start text-center m-0'>
                  You can make an instant payment link by clicking create.
                  <br />
                  You will get a link that you can forward or publish.
                </p>
                <div className='mt-md-0 mt-3 d-md-block d-flex align-items-center justify-content-center'>
                  <button
                    className={`btn btn-primary d-flex align-items-center nowrap ${user.isActive ? "" : "disabled"}`}
                    type="button"
                    onClick={() => {
                      if (user.isActive) {
                        setIsShowInstantPaymentForm(!isShowInstantPaymentForm)
                      }
                    }}
                  >
                    <i className='bx bx-plus' ></i>
                    <span className='ms-1'>Create Instant payment</span>
                  </button>
                </div>
              </div>
            </CardHeader>

            {
              isShowInstantPaymentForm ?
                <CardBody className='p-0'>
                  <hr />
                  <div className="mb-3">
                    <form
                      onSubmit={onSubmit}
                      className='row flex-column'
                    >
                      <div className='col-12 col-md-6'>
                        <Label htmlFor='transactionText pb-0'>Transaction Text*</Label>
                        <Input
                          id="transactionText"
                          type="textarea"
                          value={values.transactionText}
                          rows={3}
                          placeholder=''
                          required
                          className="form-control text-muted me-2 resize-none"
                          onChange={(event) => onChange(event, "transactionText", transactionTextMaxCount)}
                        />
                        {
                          transactionTextMaxCount ?

                            <small><i>Max {transactionTextMaxCount} characters.</i></small>
                            : null
                        }
                      </div>
                      <div className="mb-3 position-relative col-12 col-md-6 mt-3">
                        <Label htmlFor='transactionText pb-0'>Amount*</Label>
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span
                              className="input-group-text"
                            >
                              $
                            </span>
                          </div>
                          <Input
                            id="transactionAmount"
                            type="text"
                            className="form-control"
                            value={values.amount}
                            required
                            onChange={(event) => onNumberChange(event, "amount", maxAmount)}
                          />
                        </div>
                      </div>

                      <div className='position-relative col-12 col-md-6 mb-3'>
                        <div className='row'>
                          <div className='col-12 col-md-6'>
                            <Label htmlFor='transactionText pb-0'>Expiration*</Label>
                            <Input
                              id="transactionText"
                              type="date"
                              value={values.endDate}
                              min={getToday()}
                              required
                              className="form-control text-muted me-2 resize-none"
                              onChange={(event) => onDateChange(event, "endDate")}
                            />
                          </div>

                          <div className='col-12 col-md-6'>
                            <Label htmlFor='transactionText pb-0'>&nbsp;</Label>
                            <Input
                              id="transactionText"
                              type="time"
                              value={values.endTime}
                              disabled={!values.endDate}
                              required
                              className="form-control text-muted me-2 resize-none"
                              onChange={(event) => onChange(event, "endTime")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='position-relative col-12 col-md-6'>
                        <div className='row'>
                          <div className='col-12 col-md-6'>
                            <Label htmlFor='customerFullName pb-0'>Paying Customer Full Name*</Label>
                            <Input
                              id="customerFullName"
                              type="text"
                              placeholder="First Name  Last Name"
                              value={values.customerFullName}
                              required
                              className="form-control text-muted me-2 resize-none"
                              onChange={(event) => onChange(event, "customerFullName")}
                            />
                          </div>

                          <div className='col-12 col-md-6'>
                            <Label htmlFor='customerEmail pb-0'>Paying Customer Email Address*</Label>
                            <Input
                              id="customerEmail"
                              type="email"
                              placeholder='e.g. example@gmail.com'
                              value={values.customerEmail}
                              required
                              className="form-control text-muted me-2 resize-none"
                              onChange={(event) => onChange(event, "customerEmail")}
                            />
                          </div>
                        </div>
                      </div>

                      <div className='col-12 col-md-6 d-flex justify-content-end align-items-center mt-4'>
                        <Button type="button" outline color="secondary" className='shadow-sm me-2' onClick={() => setIsShowInstantPaymentForm(false)}>
                          Cancel
                        </Button>
                        <ActionButton
                          type="submit"
                          name="Create"
                          className="btn btn-primary cursor-pointer nowrap px-4"
                          spinnerId={buttonSpinnerId}
                          spinnerColor={spinnerColor}
                          disabled={values.amount && values.transactionText.trim().length && values.endDate && values.endTime && values.customerFullName && values.customerEmail ? false : true}
                        />
                      </div>
                    </form>
                  </div>
                </CardBody>
                : null
            }
          </Card>
          {
            user && !user.isActive ?
              <Card className='mb-0 mt-2'>
                <CardBody>
                  <Alert color="danger" role="alert" className='m-0'>
                    <i className="mdi mdi-block-helper me-2"></i>
                    Attention: You can't create Instant Payment with an unverified account. Please wait for approval from Cryllex administration.
                  </Alert>
                </CardBody>
              </Card>
              : null
          }
        </Col>


      </Row>
    </Col>
  )
}

export default InstantPaymentForm